import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { relationshipSelectShape } from './relationship-select-shape.js'
import { relationshipTableVar } from './relationship-table-var.js'
export function buildRelationshipSelect(
  allDbFields: SchemaField[],
  relationshipFields: SchemaField[],
  tableVar: string,
  htmlFields: SchemaField[] = [],
  extraSelects: string[] = [],
  extraJoins = ''
): string {
  const fieldSelects = allDbFields
    .filter((f) => f.type !== 'relationship')
    .map((f) => `        ${f.name}: ${tableVar}.${f.name}`)
  const htmlSelects = htmlFields.map((f) => `        ${f.name}Html: ${tableVar}.${f.name}Html`)
  const regularSelects = [...fieldSelects, ...htmlSelects].join(',\n')

  const relSelects = relationshipFields
    .map((f) => {
      const relTable = relationshipTableVar(f)
      return `        ${f.name}: ${relationshipSelectShape(f, relTable)}`
    })
    .join(',\n')

  const joins = relationshipFields
    .map((f) => {
      const relTable = relationshipTableVar(f)
      return `.leftJoin(${relTable}, eq(${tableVar}.${f.name}, ${relTable}.id))`
    })
    .join('')

  return `db.select({\n${[regularSelects, relSelects, ...extraSelects].filter(Boolean).join(',\n')}\n      }).from(${tableVar})${joins}${extraJoins}`
}
